import { inject, Injectable } from '@angular/core';
import { IRfqToDemandPort } from '@lib/rfq-detail';
import { catchError, map, Observable, of } from 'rxjs';
import { DemandDataService } from './demand-data.service';
import { RfqSettingsService } from '../rfq-settings.service';

@Injectable()
export class RfqToDemandAdapter implements IRfqToDemandPort {
    private readonly demandDataService = inject(DemandDataService);
    private readonly rfqSettingsService = inject(RfqSettingsService);

    isPurchaseRequisitionActive(): Observable<boolean> {
        return this.rfqSettingsService.purchaseRequisitionActive().pipe(
            map((response) => response.active),
            catchError(() => of(false)),
        );
    }

    createDemandFromRfq(rfqId: number): Observable<void> {
        return this.demandDataService.createDemandFromRfq(rfqId);
    }

    createDemandFromQuotation(rfqId: number, selectedQuotationItemIds: number[]): Observable<void> {
        return this.demandDataService.createDemandFromQuotation(rfqId, selectedQuotationItemIds);
    }
}
